import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8588c73c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8588c73c')) {
      api.createRecord('8588c73c', component.options)
    } else {
      api.reload('8588c73c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8588c73c", function () {
      api.rerender('8588c73c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/functional/menu/index.vue"
export default component.exports